import { render, staticRenderFns } from "./ChatReadOnlyDialog.vue?vue&type=template&id=095449a8&scoped=true&lang=pug"
import script from "./ChatReadOnlyDialog.vue?vue&type=script&lang=js"
export * from "./ChatReadOnlyDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatReadOnlyDialog.vue?vue&type=style&index=0&id=095449a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095449a8",
  null
  
)

export default component.exports